import WithFullWidthImage from './WithFullWidthImage'
export default WithFullWidthImage
